import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=18d76b07&"
import script from "./MsgDialog.vue?vue&type=script&lang=js&"
export * from "./MsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports